import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

export const HostBidsContainer = ({ accessToken, profile }) => {
  const ssoid = profile.SSOid;
  const isHost = get(profile, 'data.is_host', false);

  if (!ssoid || !accessToken) {
    return <div>Loading...</div>;
  }

  if (!isHost) {
    location.href = '/';
  }

  return (
    <div style={{ height: '100vh' }}>
      <iframe
        referrerPolicy="origin"
        style={{ width: '100%', height: '100%' }}
        src={`https://promote.peerspace.com/promoted-listings/new?host_id=${ssoid}`}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  accessToken: state.auth.accessToken,
  profile: state.profile
});

HostBidsContainer.propTypes = {
  profile: PropTypes.object.isRequired,
  accessToken: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(HostBidsContainer);
